import { defineMessage } from 'services/localization';

export const messages = {
    createdBy: defineMessage('created_by_name'),
    modifiedBy: defineMessage('last_updated_by_name'),
    noUpdatesYet: defineMessage('no_updates_since_creation'),
};
